// i18n area 'apps' — locale et-EE (task #171, onda 3): tradotto DALL'ITALIANO,
// che è la lingua SORGENTE (regola ratificata 2026-08-03); gli anglicismi del
// sorgente si TRASLANO, non si traducono. Sidecar anti-stantie: ../meta/apps.et-EE.meta.json.
import type { enUS } from './apps'

export const etEE: typeof enUS = {

  // Rakenduste 1. laine (lisa R): hallatud podman-konteinerid — worker
  // valvab neid deklareeritud sõlmel; tõmmis = lockfile branch@digest
  // (lisa Q) poliitikaga pinned/tracking; untagged L3-ühendus staatilise IP-ga.
  apps: {
    title: 'Rakendused',
    create: 'Loo rakendus',
    createTitle: 'Loo rakendus',
    editTitle: 'Muuda rakendust',
    name: 'Nimi',
    nameHint: "DNS-1123, scope'is unikaalne — pärast loomist muutumatu.",
    node: 'Sõlm',
    nodeHint: 'Liikmesõlm, mis seda teenindab — selgesõnaline paigutus (scheduler tuleb hiljem).',
    image: 'Tõmmis',
    editImageHint: 'Uus viide lahendatakse arvestuse kaudu uuesti — see ongi pin/rollback-žest.',
    imagePolicy: 'Policy',
    policyPinned: 'pinned',
    policyTracking: 'tracking',
    policyPinnedHint: 'Digest liigub ainult käsu peale.',
    policyTrackingHint: 'Automaatne rolling, kui värskendus liigutab branchi.',
    archMovePolicy: 'Cross-arch teisaldus',
    archMoveRefuse: 'refuse',
    archMoveReresolve: 'reresolve',
    archMovePolicyHint: "Mis juhtub, kui app teisaldatakse teise arhitektuuriga sõlmele: refuse keeldub teisaldusest, reresolve lahendab lockfile'i branchist uuel archil uuesti — sisu muutub ja vastus nimetab digesti muutuse.",
    network: 'Võrk',
    networkHint: 'Untagged L3-ühendus: loogiline fabric-võrk (soovitatav — gateway ja DNS selle ainsast allikast), overlay-võrk või paljas host-bridge (ei ole soovitatav).',
    overlayPrefix: 'overlay:',
    fabricPrefix: 'fabric:',
    bridgePrefix: 'host-bridge:',
    ipAssignment: 'IP määramine',
    ipStatic: 'Staatiline',
    ipAuto: 'Automaatne (IPAM)',
    ipAssignmentHint_static: 'Aadress antakse käsitsi, kohe.',
    ipAssignmentHint_auto: 'IPAM valib vaba aadressi võrgu TVirtile reserveeritud vahemikest.',
    bridgeDiscouraged: 'Paljas host-bridge — EI OLE SOOVITATAV: TVirt ei tea selle aadressistuse kohta midagi, seega gateway ja DNS tuleb anda käsitsi. Soovitatav tee on loogiline fabric-võrk.',
    ip: 'IP',
    ipHint: 'Staatiline IPv4 ühenduse alamvõrgu sees.',
    ipCidrHint: "CIDR-kujul paljal bridge'il (nt 192.168.1.10/24) — prefiksit ei ole kusagilt tuletada.",
    gateway: 'Gateway',
    gatewayManualHint: 'Käsitsi — paljas bridge ei tuleta midagi.',
    dnsServers: 'DNS-serverid',
    dnsManualHint: 'Käsitsi, komadega eraldatuna — vähemalt üks.',
    rootKind: 'Root',
    rootEphemeral: 'ajutine',
    rootPersistent: 'püsiv',
    rootEphemeralHint: "Luuakse igal taasloomisel tõmmisest uuesti; asub klastri ajutises storage'is.",
    rootEphemeralHintNamed: "Luuakse igal taasloomisel tõmmisest uuesti; asub klastri ajutises storage'is ({name}).",
    rootPersistentHint: "Elab taaskäivitused üle; asub sinu valitud storage'is.",
    rootStorage: 'Rooti storage',
    editRootStorageHint: 'Root renderdatakse uues salvestuskogumis uuesti — olemasolevad andmed EI liigu iseenesest.',
    volumes: 'Köited',
    volumeAdd: 'Lisa köide',
    volumeName: 'Nimi',
    volumeMountPath: 'Haakepunkt',
    volumeKind: 'Tüüp',
    volumeStorage: 'Storage',
    devices: 'Seadmed',
    deviceClassHint: 'Küsitakse KLASSI (silt gpu-device või usb-device), mitte kunagi konkreetset seadet: deklareeritud sõlmel peab olema mõni Appide jaoks märgitud. Mitu Appi võivad kasutada sama seadet — konteiner jagab seda, ei võta seda hostilt ära.',
    deviceSlot: 'Pesa',
    deviceTag: 'Silt',
    deviceValue: 'Klass',
    deviceUnresolved: 'praegu ei lahendu midagi',
    noDeviceTags: 'Ühtegi gpu-device või usb-device liiki silti veel pole: loo see ja määra Appide jaoks märgitud seadmetele.',
    env: 'Keskkond',
    envHint: 'Üks VÕTI=väärtus rea kohta.',
    secretEnvTitle: 'Salajased muutujad',
    secretEnvNotice: 'Salajane väärtus ei tule API-st enam kunagi tagasi: keegi ei loe seda uuesti, ka mitte see, kes selle kirjutas. Checkpointis liigub see masterpassiga pitseerituna, nii et masterpassita taastamine palub selle uuesti sisestada.',
    secretEnvPromote: 'Muuda üks ülal kirjutatud muutujatest salajaseks:',
    secretEnvAdd: 'Lisa salajane muutuja',
    secretEnvName: 'Nimi',
    secretEnvValue: 'Väärtus',
    secretEnvKept: 'säilitatud — jäta tühjaks, et seda mitte muuta',
    secretEnvWithdrawWarning: "Et lõpetada juba salajase muutuja käsitlemine salajasena, kirjuta sellele uus väärtus: üksnes märgi eemaldamine oleks viis LUGEDA seda, mis store'ist kunagi välja ei tule. Muutuja eemaldamine seevastu kustutab selle.",
    secretEnvChip: 'salajane',
    startNow: 'Käivita kohe (muidu sünnib rakendus seisatuna)',
    deletePersistentIntro: 'Sellel rakendusel on püsivad andmed — vali, mida nendega teha:',
    deleteKeepData: "Säilita andmed (kataloogid jäävad oma storage'idele alles, orbudena)",
    deletePurgeData: 'Kustuta ka andmed',
    phase: 'Faas',
    phase_running: 'Töötab',
    phase_stopped: 'Seisatud',
    phase_error: 'Viga',
    phase_unknown: 'Teadmata',
    desiredState: 'Soovitud',
    wantedRunning: 'töötab',
    wantedStopped: 'seisatud',
    start: 'Käivita',
    stop: 'Peata',
    restart: 'Taaskäivita',
    refreshImage: 'Värskenda tõmmist (võta kasutusele uus @current)',
    logs: 'Logi',
    logsTitle: 'Logi',
    logsEmpty: 'Püütud väljundit ei ole.',
    shell: 'Shell',
    shellTitle: 'Shell',
    shellUnavailable: 'App ei tööta — shell vajab elavat konteinerit. Selle logisid saab lugeda igas olekus.',
    shellConnect: 'Ühenda',
    shellDisconnect: 'Katkesta',
    shellExited: 'Seanss lõppes väljumiskoodiga {code}.',
    shellEndedWithoutStatus: 'Seanss lõppes ilma väljumisolekuta: {reason}',
    shellRevoked: 'Seansi ticket ei kehti enam — see aegus või selle avanud sisselogimine tühistati.',
    shellHint: 'Klõpsa mustal alal ja kirjuta: klahvid jõuavad konteinerisse. Ctrl+C ja nooled töötavad; exit sulgeb shelli.',
    shellStatus: {
      connecting: 'Ühendamine…',
      connected: 'Ühendatud',
      ended: 'Lõppenud'
    },
    deleteRunningError: '{name} on soovitud töötavana — peata see enne.',

    // Standarddialoog (ring #156): detailivaate sakid ja seni puudunud
    // contract-väljad — iga rakenduse väli nähtav, lukud koos põhjendusega.
    tabs: {
      general: 'Üldine',
      image: 'Tõmmis',
      network: 'Võrk',
      storage: 'Storage',
      devices: 'Seadmed',
      observed: 'Vaadeldud'
    },
    attachment: 'Ühendus',
    runningDigest: 'Töötav digest',
    lastError: 'Viimane viga',
    reportObservedAt: 'Workeri viimane raport',
    desiredStateLock: 'Seda juhivad tegevused Käivita/Peata — mitte kunagi otsene muudatus.',
    ipEditDisabledHint: 'Muudetav ainult staatilise määramise korral.',
    derivedFromNetworkHint: "Tuletatud võrgu ainsast allikast — käsitsi ainult paljal bridge'il staatilise IP-ga.",
    ephemeralUnset: 'seadistamata',
    ephemeralMissing: 'Rakenduste ajutine storage on seadistamata — ajutiste osadega (root või köited) rakenduse loomine lükatakse tagasi, kuni see on määratud.',
    ephemeralCurrent: 'Rakenduste ajutine storage: {name}',
    ephemeralMissingCreate: 'Sellel rakendusel on ajutisi osi, kuid rakenduste ajutine storage on määramata — loomine lükatakse tagasi. Määra see enne rakenduste lehe bännerilt.',
    setEphemeral: 'Määra ajutine storage',
    changeEphemeral: "Muuda ajutist storage'it",
    setEphemeralTitle: 'Määra rakenduste ajutine storage',
    changeEphemeralTitle: "Muuda rakenduste ajutist storage'it",
    ephemeralStorageHint: 'Klastri VAIKESEADE: dir-tüüpi salvestuskogum, kus asuvad iga rakenduse rootid ja ajutised köited, kui rakendus ei ole seda ise üle kirjutanud. Muutmine ei käi töö ajal ega taaskäivita midagi: see kehtib iga rakenduse järgmisest käivitusest — ajutised andmed ei liigu.',
    ephemeralPool: 'Salvestuskogum',
    ephemeralOverride: 'Ajutine storage (rakendusepõhine override)',
    ephemeralOverrideInherit: 'Päri klastri vaikeväärtus',
    ephemeralOverrideInheritNamed: 'Päri klastri vaikeväärtus ({name})',
    ephemeralOverrideHint: 'Rakendusepõhine kogum rootile ja ajutistele köidetele — jäta tühjaks, et pärida klastri vaikeväärtus. Muutmine ei käi töö ajal ega taaskäivita midagi: kehtib järgmisest käivitusest (ajutised andmed sünnivad uues kogumis tühjana) ja nõuab õigust app.ephemeralStorage.set.',
    ephemeralOverrideTag: 'override',

    imageAnyBranch: 'Kõik harud',
    imageBranchHint: 'Piirab kujutised nendega, mida see haru nimetab; ilma haruta on näha kõik repository kujutised.',
    imageDigestHint: 'Sisu: valitakse digestide tabelist, mis kannab selle päritolu ja arhitektuuri. Sama haru pakub ühe arhitektuuri kohta ja need ei ole omavahel vahetatavad.',
    imageLockfile: 'Lahendatud viide',
    imageNoImages: 'Selle repository jaoks pole vahemälus kujutisi — laadi üks alla OCI kujutiste jaotisest.',
    imageHeadNotCached: 'pole vahemälus — laaditakse alla käivitamisel',
    imageNoRegistries: 'Ühtki repositoryt pole registreeritud: registreeri üks, et saaksid kujutise valida.',
    imageChosenHint: 'Kujutis valitakse muutmisdialoogi kaskaadist: viidet ei kirjutata kunagi käsitsi.',
    registerRepositoryHint: 'Registreerimine ei laadi midagi alla: see teeb repository jälgitavaks, nii et kujutise saab valida sellest dialoogist lahkumata.',
    registerRepositoryBranchHint: 'Valikuline: esimene jälgitav haru (nt latest).',
    registerRepositoryElsewhere: 'Otsitav repository pole registreeritud: registreerimine toimub OCI kujutiste jaotises, seda teeb keegi, kellel on õigus.'
  },

  // CT-templated (ring K2 #63): MATERIALISEERITUD CT-objektid — kataloogist
  // importimine on ainus sissepääs; failid laaditakse kataloogidesse.
  cts: {
    createAction: 'Loo CT',
    createTitle: "Loo konteiner template'ist",
    createError: 'Konteinerit ei loodud',
    template: 'CT-template',
    noTemplates: "Ühtegi CT-template'i ei ole — impordi üks CT-template'ide alt",
    resources: 'Ressursid',
    node: 'Sõlm',
    phase: {
      defined: 'Kunagi käivitamata',
      materializing: 'Materialiseerimisel',
      ready: 'Valmis',
      starting: 'Käivitumisel',
      running: 'Töötab',
      stopping: 'Seiskamisel',
      stopped: 'Seisatud',
      deleting: 'Kustutamisel',
      error: 'Vigane'
    },
    actions: {
      start: 'Käivita',
      stop: 'Peata',
      restart: 'Taaskäivita',
      markTemplate: "Ülenda CT-template'iks",
      error: 'Tegevus lükati tagasi'
    },
    markTemplate: {
      confirmTitle: "Kas ülendada '{name}' CT-template'iks?",
      confirmBody: "Konteiner lahkub sellest loendist ja liigub CT-template'ite hulka, kohe valmis uusi CT-sid looma. Metaandmed jäävad muudetavaks ja selle saab igal ajal CT-ks tagasi tuua.",
      confirm: 'Ülenda',
      moved: "'{name}' on nüüd CT-template — leiad selle CT-template'ite alt."
    },
    stopCause: {
      api: 'TVirt peatas',
      'ct-exit': 'Konteiner väljus ise',
      'host-reboot': 'Suri koos sõlme taaskäivitusega',
      'start-failed': 'Käivitamine ebaõnnestus — taski viga ütleb, mis on puudu ja kuidas see korda teha'
    },

    console: 'Konsool',
    consoleUnavailable: 'Konteiner ei tööta — konsool vajab elavat konteinerit. Selle logi seevastu on loetav igas olekus.',
    consoleNoTemplate: 'Template ei tööta kunagi, seega ei ole tal konsooli: loo sellest CT ja ava selle oma.',
    consoleConnect: 'Ühenda',
    consoleDisconnect: 'Ühenda lahti',
    consoleReconnect: 'Ühenda uuesti',
    consoleTakenBy: 'Selle konsooli võttis endale teine operaator ({user}). Üks konsool konteineri kohta: uuesti ühendamine võtab selle tagasi.',
    consoleHint: 'Klõpsa mustal alal ja kirjuta: klahvid jõuavad konteinerisse. Ctrl+C ja nooled toimivad.',
    consoleEndpointDown: 'Konsooli pääsupunkti ei saa avada sõlmes, mis containerit teenindab: {cause}',
    shell: 'Shell',
    shellTitle: 'Shell',
    shellUnavailable: 'Container ei tööta — shell vajab elavat containerit. Selle logid on loetavad igas olekus.',
    shellNoTemplate: 'Template ei käivitu kunagi, seega tal pole shelli: loo sellest CT ja ava selle oma.',
    shellConnect: 'Ühenda',
    shellDisconnect: 'Katkesta',
    shellExited: 'Seanss lõppes väljumiskoodiga {code}.',
    shellEndedWithoutStatus: 'Seanss lõppes ilma väljumisolekuta: {reason}',
    shellRevoked: 'Seansi ticket ei kehti enam — see aegus või selle avanud sisselogimine tühistati.',
    shellHint: 'Klõpsa mustal alal ja kirjuta: klahvid jõuavad konteinerisse. Ctrl+C ja nooled töötavad; exit sulgeb shelli.',
    shellStatus: {
      connecting: 'Ühendamine…',
      connected: 'Ühendatud',
      ended: 'Lõppenud'
    },
    rootPassword: 'Root\'i parool',
    rootPasswordHint: 'Kirjutatakse ühe korra kopeeritud rootfs-i (hashina, enam ei näidata). Distributsioonide tõmmistel pole root\'i parooli: ilma selleta on shell ainus sissepääs.',
    sshKeys: 'Root\'i avalikud SSH-võtmed',
    sshKeysHint: 'Üks avalik OpenSSH võti rea kohta, faili root/.ssh/authorized_keys.',
    consoleStatus: {
      connecting: 'Ühendamine…',
      connected: 'Ühendatud',
      reconnecting: 'Uuesti ühendamine…'
    },
    logs: 'Logi',
    logsTitle: 'Logi',
    logsEmpty: 'Püütud väljundit ei ole.',
    logsSource: 'Milline logi',
    logsSourceConsole: 'Konteineri initi konsool — miks sees olev teenus ei käivitunud',
    logsSourceSupervisor: 'liblxc supervisor — miks konteiner ei jõudnudki tööle',
    logsNeverStarted: 'Seda ei ole kunagi käivitatud, seega ei ole veel midagi salvestatud — käivita see ja logi on olemas ka siis, kui käivitamine ebaõnnestub.',
    logsNoTemplate: 'Template ei tööta kunagi, seega ei ole ta kunagi midagi salvestanud.',
    logsError: 'Logi ei õnnestunud püüda',

    // Standarddialoog (ring #156): detailivaate sakid, mida jagavad CT-de ja
    // CT-template'ite loendid, ning lukud koos põhjendusega.
    tabs: {
      general: 'Üldine',
      hardware: 'Riistvara',
      network: 'Võrk',
      provenance: 'Päritolu'
    },
    templateFlag: 'CT-template',
    templateLock: 'Muutub ainult tegevustega Ülenda / Too tagasi CT-ks — mitte kunagi otsese muudatusega.',
    sourceLock: 'Päritolu, salvestatud sünnihetkel — mitte kunagi üle kirjutatud; surnud allikas jätab viite paljaks.',
    storageLock: 'Määratud loomisel — rootfs-i teisaldamine on tulevase ringi teema.',
    startedAt: 'Käivitatud',
    lastStop: 'Viimane peatamine',
    editNicsTitle: 'Muuda võrke',
    nicDisconnected: 'ühendamata'
  },
  ctTemplates: {
    title: "CT-template'id",
    importAction: 'Impordi kataloogist',
    importTitle: 'Impordi CT-template kataloogist',
    importSubmit: 'Impordi',
    importError: 'Import lükati tagasi',
    importHint: "Materialiseerimine kopeerib rootfs-i valitud storage'isse — kataloogi fail jääb puutumata. Uute failide lisamiseks laadi need enne mõnda kataloogi.",
    sourceFile: "CT-template'i fail",
    sourceFileHint: 'Valitud kataloogi ct-rootfs failid, ainult valmis olevad',
    noFiles: 'Selles kataloogis ei ole ühtegi valmis ct-rootfs faili — laadi üks üles kataloogi lehelt',
    source: 'Lähtefail',
    rootfsStorage: 'Rootfs-i storage',
    rootfsStorageHint: "Kus asub lahtipakitud rootfs-puu — failisüsteemiga storage, millel on vaba ruumi lahtipakitud suuruse ja umbes 1 GiB varu jagu (muidu import ebaõnnestub).",
    resources: 'Ressursid',
    cores: 'vCPU',
    memoryMiB: 'Mälu (MiB)',
    cpuLimit: 'CPU piirang',
    cpuLimitHint: 'Hosti tuumade ekvivalendid (nt 1.5); tühi = ilma ülempiirita',
    cpuUncapped: 'ilma ülempiirita',
    cpuWeight: 'CPU kaal',
    hostname: 'Hostinimi',
    hostnameHint: 'Tühi = CT nimi',
    nameservers: 'DNS-nimeserverid',
    dnsHint: 'Komadega eraldatuna; tühi = pärib hosti omad',
    searchDomains: 'DNS-i otsingudomeenid',
    dnsInherited: 'Päritud hostilt',
    networks: 'Võrgud',
    nicSlot: 'NIC-i pesa',
    phase: {
      materializing: 'Materialiseerimisel',
      ready: 'Valmis',
      deleting: 'Kustutamisel',
      error: 'Viga'
    },
    exportAction: 'Ekspordi kataloogi',
    exportTitle: 'Ekspordi kataloogi',
    exportSubmit: 'Ekspordi',
    exportError: 'Eksport lükati tagasi',
    exportHint: 'Pakib materialiseeritud rootfs-i valitud kataloogis UUDE ct-rootfs faili — template jääb puutumata.',
    exportName: 'Faili nimi',
    exportNameHint: 'Tühi = <template>-export-<n>',
    markCt: {
      action: 'Too tagasi CT-ks',
      confirmTitle: "Kas tuua '{name}' tagasi CT-ks?",
      confirmBody: 'Template lahkub sellest loendist ja naaseb CT-de loendisse, taas käivitatavana. Kuni seda uuesti ei ülendata, ei saa sellest CT-sid luua.',
      confirm: 'Too tagasi CT-ks',
      moved: "'{name}' on taas CT — leiad selle CT-de loendist."
    }
  },

  // OCI 1. laine (lisa Q — mudel silt-kui-branch): OCI silt on branch
  // (liikuv osuti), digest on commit; värskendus = "git fetch",
  // pull = lahenda PRAEGU, laadi alla SEE digest.
  oci: {
    registriesTitle: "OCI registry'd",
    imagesTitle: 'OCI tõmmised',
    provider: 'Pakkuja',
    providerDockerhub: 'Docker Hub',
    providerGhcr: 'GHCR',
    providerEcr: 'Amazon ECR',
    providerQuay: 'Red Hat Quay',
    providerGeneric: 'Üldine',
    providerImmutableHint: "Pakkuja on pärast loomist muutumatu — teine pakkuja tähendab uut registry't.",
    url: 'URL',
    urlHintPreset: 'Pakkuja järgi eeltäidetud — kirjuta üle ainult peeglite jaoks.',
    urlHintRequired: "Kohustuslik üldiste registry'de puhul: https:// baas-URL.",
    urlHintEcr: 'Kohustuslik: ECR-i lõpp-punktid on konto- ja regioonipõhised — eelseadistust ei ole.',
    credential: 'Mandaat',
    credentialNone: 'Anonüümne ligipääs',
    credentialHint: "Kasutajanime-ja-parooli kirje keystore'is; workerid lahendavad selle kasutushetkel — mitte kunagi sõlmepõhine auth-fail.",
    nameHint: "Hosti tüüpi nimi (docker.io, registry.intra); scope'i piires unikaalne, muutumatu",
    addRegistry: 'Lisa registry',
    addRegistryTitle: 'Lisa OCI registry',
    verify: 'Kontrolli',
    verifyState: 'Kontroll',
    verified: 'Kontrollitud',
    verifyFailed: 'Ebaõnnestus',
    neverVerified: 'Kunagi kontrollimata',
    registryInUseError: "'{name}' juures on veel registreeritud repositooriume — kustuta need enne.",
    repositories: 'Repositooriumid',
    repositoriesHint: 'Registreerimine jälgib branche (OCI sildid) — midagi ei laadita alla. Värskendus lahendab iga jälgitava branchi ja hoiab reflogi.',
    noRepositories: 'Selle registry juures ei ole ühtegi registreeritud repositooriumi.',
    registerRepository: 'Registreeri repositoorium',
    repoPath: 'Tee',
    repoPathHint: "Repositooriumi tee registry's, nt 'example' või 'library/nginx'",
    branches: 'Branchid',
    branchesHint: 'Jälgitavad branchid (OCI sildid), komadega eraldatuna — nt 1.1.0, 1.1.1',
    branch: 'Branch',
    branchPullHint: 'Lahendatakse PRAEGU: pull laadib alla digesti, millele branch täna osutab.',
    refresh: 'Värskenda',
    deleteRepository: 'Kustuta repositoorium',
    reflogCount: '{n} varasemat',
    noResolutions: 'Kunagi värskendamata — ühtegi lahendust ei ole vaadeldud.',
    refreshFailed: 'Viimane värskendus ebaõnnestus ({when})',
    loadError: 'Repositooriume ei õnnestunud laadida.',
    reference: 'Viide',
    digest: 'Digest',
    digestHint: 'sha256:… — täpne tõmmis, ilma branchita (detached)',
    size: 'Suurus',
    nodes: 'Sõlmed',
    detached: 'detached',
    detachedHint: 'Alla laaditud digesti järgi, ilma branchita — drifti kontroll ei kehti.',
    pulledAt: 'Alla laaditud',
    pull: 'Pull',
    pullTitle: 'Tõmmise pull',
    pullHint: 'Eelsoojendus, mitte kunagi eeltingimus: branchi järgi pull lahendab PRAEGU ja laadib alla SELLE digesti; digesti järgi pull on detached.',
    pullError: 'Pull lükati tagasi',
    pullMode: 'Pull mille järgi',
    pullModeBranch: 'Branch (lahenda kohe)',
    pullModeDigest: 'Digest (detached)',
    pullModeBranchHint: 'Aus vaikevalik: nagu apt install — hiljem uuesti tehtuna võib anda teistsuguse tõmmise.',
    pullModeDigestHint: 'Täpne digest — korratavus ja rollback; loobub drifti kontrollist.',

    // Kahe nupu muster (#88, ratifitseeritud 2026-07-30 õhtul): "registryst"
    // on olemasolev juhendatud pull, "kataloogist" materialiseerib valmis
    // oci-image arhiivi (air-gapped tee).
    importFromRegistry: "Impordi registry'st",
    importFromCatalog: 'Impordi kataloogist',
    importCatalogTitle: 'Impordi OCI tõmmis kataloogist',
    importCatalogHint: 'Air-gapped tee: valmis oci-image arhiiv (tar/tar.gz — docker-archive või oci-archive) materialiseeritakse tõmmiste hoidlasse viitega catalog/<kataloog>/<fail>@<digest>; rakendused tarbivad seda nagu iga teist tõmmist. Arhiivid laaditakse kataloogidesse — see jaotis ainult impordib.',
    importCatalogFile: 'Arhiiv',
    importCatalogFileHint: 'Valitud kataloogi valmis oci-image failid.',
    importCatalogNoFiles: 'Selles kataloogis ei ole ühtegi valmis oci-image arhiivi — laadi üks üles kataloogi vaatest.',
    importCatalogError: 'Import lükati tagasi',
    registry: 'Registry',
    repository: 'Repositoorium',
    cacheMissing: 'Klastri OCI vahemälu on seadistamata — pullid lükatakse tagasi, kuni ei ole määratud salvestuskogumit.',
    setCache: 'Määra vahemälu',
    setCacheTitle: 'Seadista OCI vahemälu',
    setCacheHint: "Klastri tasandi VAIKEKOGUM, kus hoitakse alla laaditud tõmmiste blob'e — scope võib selle oma kogumiga üle kirjutada (Scope'ide leht). Muutmine ei käi töö ajal ega taaskäivita midagi ja blob'e ei teisaldata: need ilmuvad laisalt järgmisel käivitusel või kasutusel uuesti.",
    cachePool: 'Salvestuskogum',
    changeCache: 'Muuda vahemälu',
    changeCacheTitle: 'Muuda OCI vahemälu kogumit',
    cacheCurrent: 'Klastri OCI vahemälu (vaikimisi): {name}',
    sectionOverview: 'Ülevaade',
    sectionRepositories: 'Repositooriumid',
    sectionExplore: 'Uuri',
    exploreHint: "Reaalajas kaugotsing registry's — Docker Hub täies mahus (kirjeldus, allalaadimised, tärnid), teised pakkujad best-effort. Vali tulemus, et lugeda selle täielikku kirjeldust ja sirvida kaugsilte; sildi juurest saab viite lisada TVirti repositooriumi.",
    exploreSearch: 'Otsi',
    exploreUnsupported: 'See pakkuja ei toeta otsingut.',
    exploreNoResult: 'Ühtegi vastavat repositooriumi ei leitud.',
    exploreNoTags: 'Selles repositooriumis ei ole vastavaid silte.',
    exploreOfficial: 'Ametlik',
    explorePulls: 'Allalaadimised',
    exploreStars: 'Tärnid',
    exploreUpdated: 'Uuendatud {when}',
    exploreLoadMore: 'Laadi veel',
    exploreSelectHint: 'Vali tulemus: täielik kirjeldus ja kaugsildid laaditakse siia.',
    exploreNoDescription: 'Sellelt pakkujalt ei ole kirjeldust saadaval.',
    exploreTagsTitle: 'Kaugsildid',
    exploreTagFilter: 'Otsi silte',
    exploreAddToRepo: 'Lisa repositooriumi',
    exploreAdded: '{path}:{tag} on nüüd jälgitav — vaata jaotist Repositooriumid.',
    addBranch: 'Lisa branch',
    purgeRequiredTitle: "Kas kustutada '{name}' koos tõmmistega?",
    purgeRequiredBody: 'Ükski rakendus seda repositooriumi ei kasuta, kuid allalaaditud tõmmised on veel alles: kustutamine eemaldab ka nende kirjed ning vahemälu blobid lähevad garbage collectioni kätte.',
    purgeConfirm: 'Kustuta ka tõmmised',
    providerSelectHint: 'Vali registry tüüp: kaart räägib presetist ja kasutusest.',
    providerDesc: {
      dockerhub: 'Avalik Dockeri registry: URL eeltäidetud, täielik otsing kirjelduste ja loenduritega.',
      ghcr: 'GitHub Container Registry: URL eeltäidetud; kontod kasutavad personal access tokenit.',
      ecr: 'Amazon Elastic Container Registry: otspunktid on konto- ja regioonipõhised — URL tuleb ise anda.',
      quay: 'Red Hat Quay registry: URL eeltäidetud.',
      generic: 'Ise majutatud registry (Harbor, registry:2, …): https:// URL on kohustuslik.'
    },

    // Standarddialoog (ring #156): tõmmise ja registry detailivaate väljad,
    // mida veerud ei näidanud.
    layerCount: 'Kihid',
    verifiedAt: 'Viimane kontroll',
    verifyOk: 'Tulemus',
    verifyMessage: 'Kontrolli sõnum',

    // Mudel #348/R39: kujutis ON digest — sisu — ning registry, repository ja branch on NIMED, mis selleni jõuavad.
    head: 'Head',
    heads: 'Head’id arhitektuuri kaupa',
    listDigest: 'Loendi digest',
    neverResolved: 'Kunagi lahendamata',
    totalSize: 'Kogusuurus',
    reflogTitle: 'Lahenduste ajalugu',
    usedBy: 'Kasutab',
    usageLockfile: 'lockfile',
    usageRunning: 'töötab',
    evictable: 'eemaldatav',
    evict: 'Eemalda vahemälust',
    evictHeadTitle: 'Kas eemaldada {digest}?',
    evictHeadBody: 'See on vähemalt ühe koguja praegune lahendus: eemaldamine on õiguspärane — see on ainult vahemälu, kaugbranch pakub seda endiselt — kuid see ei tohi juhtuda kogemata. Blob on ÜKS: eemaldamine tühjendab kõik kogujad, kes seda jagavad.',
    evictConfirm: 'Eemalda ikkagi',

    arch: 'Arhitektuur',
    names: 'Nimed',
    noNames: 'nimeta',
    views: 'Vaated',
    lastView: 'viimane vaade',
    evictLastViewTitle: 'Kas eemaldada viimane viide digestile {digest}?',
    evictLastViewBody: 'See on selle sisu viimane vaade: selle eemaldamisel lakkab kujutis TVirtis olemast ja baidid ({size}) vabanevad. See on mudeli docker image rm — mitte kõrvalmõju, vaid toiming ise.',
    branchesTabHint: 'Selle repository jälgitavad harud: igaühe tänased head’id — üks arhitektuuri kohta — värskenduste ajalugu ja mitu selle nimetatud kujutist on vahemälus. Värskendus on repository «git fetch»: see lahendab kõik harud korraga.',
    noBranches: 'Selles repositorys ei jälgita ühtki haru.',
    stopObserving: 'Lõpeta haru jälgimine',
    pullBranch: 'Laadi branch\'i pea vahemällu (refresh lahendab, see laadib alla)',
    pullDigest: 'Laadi see digest vahemällu',
    imageCount: 'Kujutised',
    deleteBranchPurgeTitle: 'Kas jätta {name} kujutised nimeta?',
    deleteBranchPurgeBody: 'Ükski rakendus ei nimeta seda haru, kuid mõned kujutised on saavutatavad ainult selle kaudu: kustutamisel jäävad need vahemällu nimeta, loetletuna repository kujutiste hulgas ja käsitsi eemaldatavana.',
    deleteBranchPurgeConfirm: 'Kustuta ja jäta kujutised nimeta',
    imagesTabHint: 'Selle repository kujutised — sisu, see tähendab digestid — nähtavad ka ilma haru valimata. Kujutis on klastri lõikes unikaalne: nimesid, mis selleni jõuavad, võib olla mitu.',
    noImages: 'Ühtki selle repository kujutist ei ole vahemälus materialiseeritud.',
    deleteRepositoryTitle: 'Kas kustutada {name}?',
    deleteRepositoryBody: 'Repository ja selle harud kaovad koos ajalooga. Kujutised jäävad vahemällu: nad kaotavad ainult selle nime. Repositoryt, mida rakendus nimetab, ei saa kustutada.',
    provenanceCatalog: 'kataloog',
    refreshedAt: 'Värskendatud',
    neverRefreshed: 'Pole kunagi värskendatud',
    sectionBranches: 'Harud',
    sectionImages: 'Kujutised',
    repositoriesGovernedElsewhere: 'Siin repositorysid ainult vaadatakse: nende registreerimine, värskendamine, harude jälgimine ja kujutiste eemaldamine toimub OCI kujutiste jaotises.',
    gotoImages: 'Ava OCI kujutised'
  },

  // Pod nativi (P1): the Pod list — the template's census of instances, the
  // whole-Pod lifecycle, the scale and the delete.
  pods: {
    title: 'Podid',
    containers: 'Konteinerid',
    instances: 'Eksemplarid',
    instancesTooltip: '{running} töötab, {error} veaga',
    placement: 'Paigutus',
    spread: 'hajutus',
    ha: 'HA',
    templateRevision: 'redaktsioon',
    deleting: 'Kustutamisel',
    empty: 'Pode pole — loo rakendus (üks konteiner) või pod CLI kaudu (create-pod).',
    openInstances: 'Ava eksemplarid',
    rollingRestart: 'Järkjärguline taaskäivitus',
    scale: 'Skaleeri',
    scaleTitle: 'Skaleeri {name}',
    scaleHint: 'Eksemplaride arv (0–64): üles täidetakse madalaim vaba järjekorranumber, alla võetakse kõrgeim ära ja selle püsiandmed jäävad alles.',
    scaleError: 'Skaleerimine ebaõnnestus',
    replicas: 'Koopiad',
    deleteRunningError: '{name} töötab — peata see enne.',
    deleteInstancesIntro: 'Kõik {count} eksemplari eemaldatakse.',
    stateRunning: 'Töötab',
    stateStopped: 'Peatatud',
    editor: {
      createTitle: 'Loo Pod',
      create: 'Loo Pod',
      editTitle: 'Muuda Podi',
      nameHint: 'DNS-1123, kuni 58 märki — eksemplarid nimetatakse <nimi>-<indeks>; pärast loomist muutumatu.',
      restartPolicy: 'Taaskäivituspoliitika',
      restartPolicyHint_always: 'Sõlm taaskäivitab iga lõppenud konteineri eksponentsiaalse ootega (10 s → 5 min).',
      restartPolicyHint_onFailure: 'Taaskäivitatakse ainult nullist erineva koodiga lõppenud konteiner; väljumine 0 jääb puhkama.',
      restartPolicyHint_never: 'Lõppenud konteiner jäetakse nii, nagu on — eksemplar lõpeb olekus succeeded või failed.',
      grace: 'Ooteaeg (s)',
      graceHint: 'Peatamise SIGTERM → SIGKILL piir.',
      hostname: 'Hostinimi',
      hostnameHint: 'Tühi = eksemplari nimi.',
      hostnameDefault: 'eksemplari nimi',
      sharePid: 'Jaga PID-nimeruumi konteinerite vahel',
      containersIntro: 'Init-konteinerid jooksevad järjekorras lõpuni enne konteinerite käivitumist; konteinerid jagavad eksemplari võrku (üks IP, localhost omavahel).',
      initContainers: 'Init-konteinerid',
      initAdd: 'Lisa init-konteiner',
      initHint: 'Igaüks peab lõppema koodiga 0; ebaõnnestumine viib eksemplari vea olekusse ja sõlm proovib ootega uuesti.',
      containerAdd: 'Lisa konteiner',
      atLeastOne: 'Pod vajab vähemalt ühte konteinerit.',
      duplicateNames: 'Konteinerite nimed peavad Podis olema unikaalsed (kaasa arvatud init-konteinerid).',
      containerName: 'Konteineri nimi',
      containerInvalid: 'See konteiner on puudulik: nimi (DNS-1123), tõmmis, haakimised deklareeritud köidetele, arvulised piirid ja sond.',
      command: 'Käsk',
      commandHint: 'Asendab tõmmise entrypointi — üks argument rea kohta, mitte kunagi kestastring.',
      args: 'Argumendid',
      argsHint: 'Üks rea kohta (tõmmise CMD, kui tühi).',
      mounts: 'Haakimised',
      mountAdd: 'Lisa haakimine',
      mountNoVolumes: 'Deklareeri esmalt köide vahekaardil Salvestus.',
      readOnly: 'kirjutuskaitstud',
      resources: 'Piirid',
      cpus: 'CPU',
      cpusHint: 'podman --cpus (nt 1.5)',
      memory: 'Mälu (MiB)',
      memoryHint: 'podman --memory',
      health: 'Elusoleku sond',
      healthCmd: 'Sondi käsk',
      healthCmdHint: 'Sõlm käivitab selle konteineris igal järelevalvetaktil — üks argument rea kohta; väljumine 0 = terve.',
      healthTimeout: 'Ajapiirang (s)',
      healthRetries: 'Katsed',
      healthRetriesHint: 'Järjestikused ebaõnnestumised, enne kui sõlm konteineri taaskäivitab.',
      ips: 'Staatilised aadressid',
      ipsHint: 'Üks eksemplari kohta, järjenumbri järjekorras — nimekirjast üle skaleerimine lükatakse tagasi.',
      instance: 'eksemplar',
      volumesHint: 'Köited kuuluvad Podile; haakimistee kuulub igale konteinerile (vahekaart Konteinerid).',
      spread: 'Hajutus',
      spreadHint_preferred: 'Eksemplarid võimalusel eri sõlmedel.',
      spreadHint_required: 'Eksemplarid eri sõlmedel, muidu skaleerimine keeldub.',
      spreadHint_none: 'Ainult otsustaja.',
      ha: 'Kõrgkäideldavus (opt-in)',
      haHint: 'Iga püsiv osa jagatud salvestil; kui sõlm sureb, loob HA decider eksemplarid uuesti teises liikmes (automaatne failover, nagu HA VM-idel).',
      yes: 'jah',
      no: 'ei'
    },
    detail: {
      container: 'Konteiner',
      actions: 'Toimingud',
      ready: 'Valmis',
      notReady: 'Pole valmis',
      restarts: 'Taaskäivitused',
      lastRestartAt: 'Viimane taaskäivitus:',
      backoffUntil: 'Uus katse kell',
      stateAbsent: 'puudub',
      stateRunning: 'töötab',
      stateTerminated: 'lõppenud',
      stateWaiting: 'ootab',
      init: 'init',
      noInstances: 'Eksemplare pole (koopiaid 0).',
      ha: 'HA',
      haHint: 'Automaatne failover: kui sõlm sureb, loob HA decider eksemplari uuesti teises liikmes (iga püsiv osa jagatud salvestil).',
      authority: 'Authority (sõlm)',
      homeless: 'ilma authorityta',
      homelessHint: 'Checkpointist taastamine jätab authority välja (#380): ükski sõlm seda ei teeninda, kuni Pod-i skaleerid (kas või sama koopiate arvuni).',
      restartContainer: 'Taaskäivita ainult see konteiner (pod jääb püsti)',
      divergingHint: 'Selle eksemplari soovitud olek erineb Podi vaikimisi olekust (PD-P19).',
      revisionLag: 'revisjon {applied} rakendatud, praegune {current}',
      updatedInstances: '{updated}/{desired} eksemplari sellel revisjonil'
    }
  }
}
